<template>
  <el-select
    v-model="unitOfMeasureModel"
    @change="unitOfMeasureChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.UNIT_OF_MEASURE')"
    :filterable="filterable"
    :disabled="disabled"
    remote
    :remote-method="getUnitOfMeasures"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.ALL_UNIT_OF_MEASURES')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="unitOfMeasure in unitOfMeasures"
      :key="unitOfMeasure.id"
      :value="unitOfMeasure.id"
      :label="`${unitOfMeasure.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "unit-of-measure-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    unitOfMeasure: {
      type: String,
      default: null,
      description: "UnitOfMeasure id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterIdsNotIn: {
      type: Array,
      default: () => [],
      description: "Id not in",
    },
  },

  data() {
    return {
      unitOfMeasureModel: this.unitOfMeasure ?? null,
      unitOfMeasures: {},
    };
  },

  setup() {},

  created() {
    this.getUnitOfMeasures(null, this.unitOfMeasure);
  },

  methods: {
    async getUnitOfMeasures(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { search: query } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterIdsNotIn.length > 0) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              idsNotIn: this.filterIdsNotIn,
            },
          };
        }

        await this.$store.dispatch("unitOfMeasures/list", params);
        const unitOfMeasuresArr = await this.$store.getters[
          "unitOfMeasures/list"
        ];
        this.unitOfMeasures = {};
        unitOfMeasuresArr.forEach((unitOfMeasure) => {
          this.unitOfMeasures[unitOfMeasure.id] = unitOfMeasure;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    unitOfMeasureChanged(unitOfMeasure) {
      this.$emit("unitOfMeasureChanged", unitOfMeasure);
    },
  },

  watch: {
    unitOfMeasure(unitOfMeasure) {
      if (unitOfMeasure) {
        this.unitOfMeasureModel = unitOfMeasure;
        this.getUnitOfMeasures(null, unitOfMeasure);
      } else {
        this.unitOfMeasureModel = null;
        this.getUnitOfMeasures();
      }
    },
    filterOrganization(filterOrganization) {
      this.getUnitOfMeasures();
    },
  },
};
</script>
